import React, { forwardRef, useImperativeHandle, useState } from "react";

import { Box } from "@chakra-ui/react";
import { MenuContent, MenuRoot } from "components/ui/menu";
import { POPUP_WRAPPER_ZINDEX } from "utils/constants";

import { filterPopUpMenuContentCss } from "./styles";
import { IFilterPopUpProp, IFilterPopUpRef } from "./types";

export const FilterPopUp = forwardRef<IFilterPopUpRef, IFilterPopUpProp>(
  (props, ref) => {
    const { position, children, customFilterPopUpCss } = props;
    const [open, setOpen] = useState(false);

    const handleToggle = () => setOpen(!open);
    const handleClose = () => setOpen(false);

    useImperativeHandle(ref, () => ({
      isPopUpOpen: open,
      handleTogglePopup: handleToggle,
    }));

    return (
      <>
        {open && (
          <Box
            className="fixed top-0 left-0 w-screen h-screen z-[1100]"
            onClick={handleClose}
          />
        )}
        <MenuRoot
          open={open}
          onInteractOutside={(evt) => {
            if (!evt.target) return;
            const target = evt.target as Element;
            if (target.closest(".filter-popup-menu-content")) return;
            handleClose();
          }}
          anchorPoint={{ x: position.left, y: position.top }}
        >
          <MenuContent
            css={{
              ...filterPopUpMenuContentCss,
              ...customFilterPopUpCss,
              zIndex: POPUP_WRAPPER_ZINDEX,
            }}
            className="filter-popup-menu-content"
            onClick={(evt) => evt.stopPropagation()}
          >
            {children}
          </MenuContent>
        </MenuRoot>
      </>
    );
  }
);
